<template>
  <CCard class="chart-card chart-card--purple">
    <CCardHeader class="border-bottom-0 py-2">
      <div class="d-flex align-items-center">
        <h5 class="my-2" v-translate translate-context="salesReport.list">SaaS</h5>
        <div class="ml-2">
          <template v-if="saasPaymentsList && saasPaymentsList.pagination && saasPaymentsList.pagination.total_count">
            ({{ saasPaymentsList.pagination.total_count | number }})
          </template>
        </div>
      </div>
      <div class="card-header-actions">
        <div class="d-flex align-items-center">
          <h6 class="dot dot-purple font-weight-bold m-0" style="font-size: 15px">
            {{ saasPaymentsTotal && saasPaymentsTotal.total_amount | currency(currencyCodes.EUR) }}
          </h6>
          <CButton :class="['btn-grid-toggle', 'pr-0', {'on': isExpanded}]"
                   @click="toggleExpanded"/>
        </div>
      </div>
    </CCardHeader>
    
    <CCollapse :show="Boolean(isExpanded)" :duration="collapseDuration">
      <div style="min-height: 100px">
        <CCardBody class="p-0">
          <template v-if="isExpanded">
            <AjaxTable
                :fields="saasPaymentsListFields"
                :data="saasPaymentsList"
                :fetch="fetchSaasPaymentsList">
              
              <template #amount_eur="{ item }">
                <td class="text-right">
                  {{ item.amount_eur | currency(currencyCodes.EUR) }}
                </td>
              </template>
              
              <template #created_at="{ item }">
                <td>{{ item.created_at | formatDate('L LT') }}</td>
              </template>
              
            </AjaxTable>
          </template>
        </CCardBody>
      </div>
    </CCollapse>
  </CCard>
</template>

<script>
import AjaxTable from "@/domain/core/components/AjaxTable.vue"
import { mapGetters, mapActions } from "vuex"
import { currencyCodes } from "@/constants"
import { saasPaymentsListFields } from "../constants"

export default {
  name: "SaasPaymentsList",
  components: { AjaxTable },

  props: {
    autoExpand: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isExpanded: false,
      collapseDuration: 0
    }
  },

  async mounted() {
    if (this.autoExpand) {
      await this.expandList()
    }
  },

  watch: {
    async autoExpand(newVal) {
      if (newVal) {
        await this.expandList()
      }
    }
  },

  computed: {
    ...mapGetters('salesReport', [
      'saasPaymentsTotal',
      'saasPaymentsList'
    ]),
    
    currencyCodes() {
      return currencyCodes
    },
    
    saasPaymentsListFields() {
      return Object.values(saasPaymentsListFields)
    }
  },
  
  methods: {
    ...mapActions('salesReport', ['fetchSaasPaymentsList']),

    async expandList() {
      await this.fetchSaasPaymentsList()
      this.isExpanded = true
    },

    toggleExpanded() {
      this.isExpanded = !this.isExpanded
      this.collapseDuration = 300
      this.$nextTick(() => {
        this.collapseDuration = 0
      })
    }
  }
}
</script>

